interface BetweenOptions {
    min: number;
    value: number | string;
    max: number;
    round: number;
    step?: number;
}

export const between = ({ min, value, max, round, step = 0 }: BetweenOptions): number => {
    const currentValue = Number.parseInt(value.toString(), 10) + step;

    return !Number.isSafeInteger(currentValue) || currentValue > max
        ? max
        : currentValue < min
          ? min
          : currentValue - (currentValue % round);
};
